import { useEffect } from "react";

function setMetaTag(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
    }
    if (keywords) {
      setMetaTag("name", "keywords", keywords);
    }
    setMetaTag("property", "og:title", title);
  }, [title, description, keywords]);
}